<div class="modal-overlay" (click)="closeModal()">
    <div class="modal-container" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h2 class="modal-title">{{ taskId ? 'Edit Task' : 'Create Task' }}</h2>
            <div class="modal-actions">
                <button class="modal-action-btn" (click)="closeModal()" title="Close">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </button>
            </div>
        </div>

        <div class="modal-content">
            <form [formGroup]="taskForm" class="task-form">

                <!-- Due Date Row -->
                <div class="meta-row date-row">
                    <div class="meta-item due-date">
                        <div [ngClass]="getDueDateClass()" class="meta-icon"></div>
                        <span [ngClass]="getDueDateClass()" class="meta-date-text">{{ formattedDueDate }}</span>
                        <label for="dueDateInput" class="change-date-btn" (click)="changeDueDate($event)">
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <rect x="2" y="3" width="10" height="9" rx="1.5" stroke="currentColor"
                                    stroke-width="1.2" />
                                <path d="M9 1V5M5 1V5M2 6H12" stroke="currentColor" stroke-width="1.2"
                                    stroke-linecap="round" />
                            </svg>
                            Change Date
                        </label>
                        <input id="dueDateInput" type="date" formControlName="dueDate" class="hidden-date-input">
                    </div>
                    <div class="creator-info-small" *ngIf="task && task.creator">
                        Created by <span class="creator-name">{{ task.creator.username }}</span> • {{
                        formatActivityDate(task.createdAt) }}
                    </div>
                </div>

                <!-- Task Title - Editable -->
                <div class="task-title-section">
                    <input type="text" formControlName="name" class="task-title-input" placeholder="Enter task title..."
                        [class.error]="taskForm.get('name')?.invalid && taskForm.get('name')?.touched">
                </div>

                <!-- Task Meta Info -->
                <div class="task-meta-wrapper">
                    <!-- Labels Row -->
                    <div class="meta-row info-row">
                        <div class="meta-left">
                            <div class="meta-item">
                                <div class="meta-label">Status</div>
                                <select formControlName="status" class="status-select">
                                    <option *ngFor="let status of statusOptions" [value]="status">
                                        {{ status.replace('_', ' ') | titlecase }}
                                    </option>
                                </select>
                            </div>

                            <div class="meta-item">
                                <div class="meta-label">Priority</div>
                                <select formControlName="priority" class="priority-select"
                                    [class]="taskForm.get('priority')?.value?.toLowerCase()">
                                    <option *ngFor="let priority of priorityOptions" [value]="priority">
                                        {{ priority | titlecase }} Priority
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="meta-right">
                            <div class="meta-item assignee-item">
                                <div class="meta-label">Assigned To</div>
                                <div class="assignee-section">
                                    <div class="assignee-chip" *ngIf="selectedUser">
                                        <ng-template #userInitials>
                                            <div class="assignee-avatar initials">
                                                {{ getUserInitials(selectedUser.username) }}
                                            </div>
                                        </ng-template>
                                        <span class="assignee-name">{{ selectedUser.username }}</span>
                                        <button type="button" class="remove-assignee" (click)="removeAssignee()">
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                <path d="M10 4L4 10M4 4L10 10" stroke="currentColor" stroke-width="1.5"
                                                    stroke-linecap="round" />
                                            </svg>
                                        </button>
                                    </div>

                                    <div class="" style="justify-content: end;"
                                        *ngIf="taskId && selectedUser && task?.assigneeId != currentUser?.id">
                                        <div class="nudge-section">
                                            <span class="last-nudged mr-2" *ngIf="task?.lastNudgedAt">
                                                Last nudged {{ formatActivityDate(task?.lastNudgedAt) }}
                                            </span>
                                            <button type="button" class="nudge-link" (click)="nudgeAssignee()"
                                                *ngIf="canNudge()" title="Nudge assignee">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                                    stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                    stroke-linejoin="round">
                                                    <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"></path>
                                                    <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"></path>
                                                </svg>
                                                <span>Nudge</span>
                                            </button>
                                        </div>
                                    </div>

                                    <div class="dropdown" *ngIf="!selectedUser"
                                        (clickOutside)="showAssigneeDropdown = false">
                                        <button type="button" class="dropdown-trigger"
                                            [class.open]="showAssigneeDropdown"
                                            (click)="toggleAssigneeDropdown($event)">
                                            <span>Select assignee...</span>
                                            <svg class="dropdown-icon" [class.open]="showAssigneeDropdown" width="12"
                                                height="12" viewBox="0 0 12 12" fill="none">
                                                <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.5"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </button>

                                        <div class="dropdown-menu" *ngIf="showAssigneeDropdown">
                                            <div class="dropdown-search">
                                                <input type="text" placeholder="Search users..."
                                                    [(ngModel)]="assignSearchQuery"
                                                    [ngModelOptions]="{standalone: true}"
                                                    (click)="$event.stopPropagation()">
                                            </div>
                                            <div class="dropdown-list">
                                                <div class="dropdown-item" *ngFor="let user of getFilteredUsers()"
                                                    (click)="selectUser(user, $event)">
                                                    <ng-template #initials>
                                                        <div class="user-avatar">
                                                            <span>{{ getUserInitials(user.username) }}</span>
                                                        </div>
                                                    </ng-template>
                                                    <div class="user-info">
                                                        <div class="user-name">{{ user.username }}</div>
                                                        <div class="user-role">{{ user.role.name }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="meta-row watchers-row">
                        <div class="meta-item watchers-item">
                            <div class="meta-label">
                                Watchers
                                <span class="label-info">(Optional - Users who will receive notifications)</span>
                            </div>

                            <!-- Watcher Selector -->
                            <div class="watchers-selector">
                                <div class="select-wrapper">
                                    <select [(ngModel)]="selectedWatcherToAdd" [ngModelOptions]="{standalone: true}"
                                        (change)="addWatcher($event)" class="watcher-select">
                                        <option value="">Add a watcher...</option>
                                        <option *ngFor="let user of availableWatcherOptions()" [value]="user.value">
                                            {{ user.label }}
                                        </option>
                                    </select>
                                    <svg class="select-arrow" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                        <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </div>

                            <!-- Watchers Chips Display -->
                            <div class="watchers-chips" [class.empty]="currentWatchers().length === 0">
                                <div class="empty-state" *ngIf="currentWatchers().length === 0">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2" />
                                        <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                    <span>No watchers added</span>
                                </div>

                                <div class="watcher-chip"
                                    *ngFor="let watcher of currentWatchers(); trackBy: trackByWatcherId">
                                    <div class="watcher-avatar">
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor"
                                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2" />
                                        </svg>
                                    </div>
                                    <span class="watcher-name">{{ watcher.username }}</span>
                                    <button type="button" class="remove-watcher" (click)="removeWatcher(watcher.id)"
                                        [attr.aria-label]="'Remove ' + watcher.username">
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                            <path d="M9 3L3 9M3 3L9 9" stroke="currentColor" stroke-width="1.5"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-section related-entity">

                    <div>
                        <div class="section-header">
                            <h3 class="meta-label">Related To (Optional)</h3>
                        </div>

                        <div class="related-entity-wrapper">
                            <!-- Selected Entity Display -->
                            <div class="related-entity-chip" *ngIf="selectedRelatedEntity">
                                <svg class="entity-icon" width="16" height="16">
                                    <use [attr.xlink:href]="'assets/icons/' + getRelatedEntityIcon() + '.svg'"></use>
                                </svg>
                                <span class="entity-type">{{ getRelatedEntityTypeLabel() }}:</span>
                                <span class="entity-name">{{ selectedRelatedEntity.name }}</span>
                                <button type="button" class="remove-entity" (click)="removeRelatedEntity()">
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                        <path d="M10 4L4 10M4 4L10 10" stroke="currentColor" stroke-width="1.5"
                                            stroke-linecap="round" />
                                    </svg>
                                </button>
                            </div>

                            <!-- Dropdown Trigger -->
                            <div class="dropdown" *ngIf="!selectedRelatedEntity"
                                (clickOutside)="showRelatedDropdown = false">
                                <button type="button" class="dropdown-trigger related-trigger"
                                    [class.open]="showRelatedDropdown" (click)="toggleRelatedDropdown($event)">

                                    <!-- Lead Icon -->
                                    <svg class="entity-icon" width="16" height="16" viewBox="0 0 24 24" fill="none"
                                        *ngIf="relatedEntityType === 'lead'">
                                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" stroke="currentColor"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2" />
                                        <path d="M22 21v-2a4 4 0 0 0-3-3.87" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>

                                    <!-- Client Icon -->
                                    <svg class="entity-icon" width="16" height="16" viewBox="0 0 24 24" fill="none"
                                        *ngIf="relatedEntityType === 'client'">
                                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2" />
                                    </svg>

                                    <!-- Opportunity Icon -->
                                    <svg class="entity-icon" width="16" height="16" viewBox="0 0 24 24" fill="none"
                                        *ngIf="relatedEntityType === 'opportunity'">
                                        <path
                                            d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>

                                    <span>Select {{ getRelatedEntityTypeLabel() }}...</span>

                                    <svg class="dropdown-icon" [class.open]="showRelatedDropdown" width="12" height="12"
                                        viewBox="0 0 12 12" fill="none">
                                        <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </button>

                                <!-- Dropdown Menu -->
                                <div class="dropdown-menu related-dropdown" *ngIf="showRelatedDropdown">
                                    <!-- Entity Type Tabs -->
                                    <div class="entity-type-tabs">
                                        <button type="button" class="entity-tab"
                                            [class.active]="relatedEntityType === 'lead'"
                                            (click)="changeRelatedType('lead', $event)">
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
                                                    stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2" />
                                                <path d="M22 21v-2a4 4 0 0 0-3-3.87" stroke="currentColor"
                                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor"
                                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                            Lead
                                        </button>
                                        <button type="button" class="entity-tab"
                                            [class.active]="relatedEntityType === 'client'"
                                            (click)="changeRelatedType('client', $event)">
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
                                                    stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2" />
                                            </svg>
                                            Client
                                        </button>
                                        <button type="button" class="entity-tab"
                                            [class.active]="relatedEntityType === 'opportunity'"
                                            (click)="changeRelatedType('opportunity', $event)">
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                                <path
                                                    d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                                                    stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                            Opportunity
                                        </button>
                                    </div>

                                    <!-- Search Input -->
                                    <div class="dropdown-search">
                                        <input type="text" placeholder="Search {{ getRelatedEntityTypeLabel() }}..."
                                            [value]="relatedSearchQuery" (input)="onRelatedSearchInput($event)"
                                            (click)="$event.stopPropagation()">
                                    </div>

                                    <!-- Results List -->
                                    <div class="dropdown-list">
                                        <div class="search-loading" *ngIf="isSearchingRelated">
                                            <div class="small-spinner"></div>
                                            <span>Searching...</span>
                                        </div>

                                        <div class="dropdown-item" *ngFor="let entity of relatedEntities"
                                            (click)="selectRelatedEntity(entity, $event)">

                                            <!-- Lead Icon -->
                                            <svg class="entity-icon" width="16" height="16" viewBox="0 0 24 24"
                                                fill="none" *ngIf="relatedEntityType === 'lead'">
                                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
                                                    stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2" />
                                                <path d="M22 21v-2a4 4 0 0 0-3-3.87" stroke="currentColor"
                                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor"
                                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>

                                            <!-- Client Icon -->
                                            <svg class="entity-icon" width="16" height="16" viewBox="0 0 24 24"
                                                fill="none" *ngIf="relatedEntityType === 'client'">
                                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
                                                    stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2" />
                                            </svg>

                                            <!-- Opportunity Icon -->
                                            <svg class="entity-icon" width="16" height="16" viewBox="0 0 24 24"
                                                fill="none" *ngIf="relatedEntityType === 'opportunity'">
                                                <path
                                                    d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                                                    stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>

                                            <div class="entity-info">
                                                <div class="entity-name">{{ entity.name }}</div>
                                            </div>
                                        </div>

                                        <div class="no-results"
                                            *ngIf="!isSearchingRelated && relatedEntities.length === 0 && relatedSearchQuery">
                                            No {{ getRelatedEntityTypeLabel().toLowerCase() }}s found
                                        </div>

                                        <div class="dropdown-hint"
                                            *ngIf="!isSearchingRelated && relatedEntities.length === 0 && !relatedSearchQuery">
                                            Type to search {{ getRelatedEntityTypeLabel().toLowerCase() }}s
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="meta-item branch-item" *ngIf="showBranchField">
                        <div class="section-header">
                            <h3 class="meta-label">Branch<span class="required-indicator">*</span></h3>
                        </div>
                        <div class="branch-select-wrapper">
                            <select formControlName="branchId" class="branch-select"
                                [class.error]="taskForm.get('branchId')?.invalid && taskForm.get('branchId')?.touched">
                                <option value="">Select branch...</option>
                                <option *ngFor="let branch of availableBranches()" [value]="branch.id">
                                    {{ branch.name }}
                                </option>
                            </select>
                            <svg class="select-arrow" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="error-message"
                            *ngIf="taskForm.get('branchId')?.invalid && taskForm.get('branchId')?.touched">
                            Branch is required
                        </div>
                    </div>
                </div>

                <!-- Recurring Task Section -->
                <div class="form-section recurring-task">
                    <div class="section-header">
                        <h3 class="meta-label">Recurring Task</h3>
                        <label class="toggle-switch">
                            <input type="checkbox" [(ngModel)]="isRecurring" [ngModelOptions]="{standalone: true}">
                            <span class="toggle-slider"></span>
                        </label>
                    </div>

                    <div class="recurring-options" *ngIf="isRecurring">
                        <div class="recurring-row">
                            <div class="recurring-item">
                                <label class="recurring-label">Frequency</label>
                                <select [(ngModel)]="frequency" [ngModelOptions]="{standalone: true}"
                                    class="recurring-select">
                                    <option *ngFor="let option of frequencyOptions" [value]="option.value">
                                        {{ option.label }}
                                    </option>
                                </select>
                            </div>

                            <div class="recurring-item">
                                <label class="recurring-label">Start Date</label>
                                <input type="date" [(ngModel)]="startDate" [ngModelOptions]="{standalone: true}"
                                    class="recurring-input">
                            </div>
                        </div>

                        <div class="recurring-row">
                            <div class="recurring-item">
                                <label class="recurring-label">Create Days in Advance</label>
                                <input type="number" [(ngModel)]="daysInAdvance" [ngModelOptions]="{standalone: true}"
                                    min="1" max="30" class="recurring-input">
                            </div>

                            <div class="recurring-item">
                                <label class="recurring-label">End Date (Optional)</label>
                                <input type="date" [(ngModel)]="endDate" [ngModelOptions]="{standalone: true}"
                                    class="recurring-input">
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Description Section -->
                <div class="form-section description">
                    <div class="section-header">
                        <h3 class="section-title">Description</h3>
                    </div>
                    <div>
                        <div #editor></div>
                    </div>

                    <!-- Attachments -->
                    <div class="attachments-section">
                        <button type="button" class="attach-btn" (click)="fileInput.click()">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path
                                    d="M8.5 2L8.5 10.5C8.5 11.8807 7.38071 13 6 13C4.61929 13 3.5 11.8807 3.5 10.5V5.5C3.5 4.67157 4.17157 4 5 4C5.82843 4 6.5 4.67157 6.5 5.5V10"
                                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                            </svg>
                            Add attachment
                        </button>
                        <input #fileInput type="file" multiple class="hidden" (change)="onFileSelected($event)">

                        <div class="file-chips" *ngIf="uploadedFiles.length > 0">
                            <div class="file-chip" *ngFor="let file of uploadedFiles; let i = index">
                                <div class="file-info">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" class="file-icon">
                                        <path
                                            d="M9 1H4C3.44772 1 3 1.44772 3 2V14C3 14.5523 3.44772 15 4 15H12C12.5523 15 13 14.5523 13 14V5L9 1Z"
                                            stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                                        <path d="M9 1V5H13" stroke="currentColor" stroke-width="1.5"
                                            stroke-linejoin="round" />
                                    </svg>
                                    <div class="file-details">
                                        <span class="file-name">{{ file.fileName }}</span>
                                        <span class="file-size">{{ formatFileSize(file.fileSize) }}</span>
                                    </div>
                                </div>
                                <div class="file-actions">
                                    <button type="button" class="action-btn view-btn" (click)="viewFile(file)"
                                        title="View">
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                            <path d="M1 6C1 6 3 2 6 2C9 2 11 6 11 6C11 6 9 10 6 10C3 10 1 6 1 6Z"
                                                stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                                            <circle cx="6" cy="6" r="2" stroke="currentColor" stroke-width="1.5" />
                                        </svg>
                                    </button>
                                    <button type="button" class="action-btn delete-btn" (click)="deleteFile(file, i)"
                                        title="Delete">
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                            <path d="M9 3L3 9M3 3L9 9" stroke="currentColor" stroke-width="1.5"
                                                stroke-linecap="round" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Comments Section -->
                <div class="form-section" *ngIf="taskId">
                    <div class="section-header">
                        <h3 class="section-title">Comments</h3>
                    </div>

                    <!-- Comments List -->
                    <div class="comments-list" *ngIf="comments.length > 0">
                        <div class="comment-item" *ngFor="let comment of comments; let i = index">
                            <div class="comment-avatar-wrapper">
                                <img *ngIf="comment.author.avatar" [src]="comment.author.avatar" [alt]="comment.author"
                                    class="comment-avatar">
                                <div *ngIf="!comment.author.avatar" class="comment-avatar initials">
                                    {{ getUserInitials(comment.author.username) }}
                                </div>
                            </div>

                            <div class="comment-content">
                                <div class="comment-header">
                                    <span class="comment-author">{{ comment.author.username }}</span>
                                    <span class="comment-date">{{ formatCommentDate(comment.createdAt) }}</span>
                                    <span class="comment-edited"
                                        *ngIf="comment.updatedAt != comment.createdAt">(edited)</span>

                                    <div class="comment-actions"
                                        *ngIf="canEditComment(comment) && isCommentEditable(comment)">
                                        <button type="button" class="comment-action edit"
                                            [class.editing]="comment.isEditing"
                                            (click)="comment.isEditing ? cancelCommentEdit(comment) : editComment(comment)"
                                            [title]="comment.isEditing ? 'Cancel' : 'Edit'">
                                            <!-- Edit/Cancel icon toggle -->
                                            <svg *ngIf="!comment.isEditing" width="16" height="16" viewBox="0 0 16 16"
                                                fill="none">
                                                <path d="M11.5 2L14 4.5L5 13.5L1.5 14L2.5 10.5L11.5 2Z"
                                                    stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                                                <path d="M10 3.5L12.5 6" stroke="currentColor" stroke-width="1.5"
                                                    stroke-linecap="round" />
                                            </svg>
                                            <svg *ngIf="comment.isEditing" width="16" height="16" viewBox="0 0 16 16"
                                                fill="none">
                                                <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </button>
                                        <button type="button" class="comment-action delete"
                                            (click)="deleteComment(comment, i)" title="Delete">
                                            <!-- Dustbin/trash icon -->
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path
                                                    d="M2 4H14M12 4V13C12 13.5523 11.5523 14 11 14H5C4.44772 14 4 13.5523 4 13V4M6.5 1H9.5C9.77614 1 10 1.22386 10 1.5V4H6V1.5C6 1.22386 6.22386 1 6.5 1Z"
                                                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <path d="M7 7V11M9 7V11" stroke="currentColor" stroke-width="1.5"
                                                    stroke-linecap="round" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>

                                <div *ngIf="!comment.isEditing" class="comment-body-editor"
                                    [attr.data-readonly-comment]="comment.id"></div>

                                <!-- Edit Mode -->
                                <div *ngIf="comment.isEditing" class="comment-edit">
                                    <div class="comment-editor" [attr.data-comment-id]="comment.id">
                                        <!-- Quill editor will be initialized here -->
                                    </div>

                                    <!-- Edit File Attachments -->
                                    <div class="edit-files-section"
                                        *ngIf="comment.editFiles && comment.editFiles.length > 0">
                                        <div class="file-chips">
                                            <div class="file-chip small"
                                                *ngFor="let file of comment.editFiles; let fi = index">
                                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                                    class="file-icon">
                                                    <path
                                                        d="M7 1H3C2.44772 1 2 1.44772 2 2V10C2 10.5523 2.44772 11 3 11H9C9.55228 11 10 10.5523 10 10V4L7 1Z"
                                                        stroke="currentColor" stroke-width="1.5"
                                                        stroke-linejoin="round" />
                                                    <path d="M7 1V4H10" stroke="currentColor" stroke-width="1.5"
                                                        stroke-linejoin="round" />
                                                </svg>
                                                <span class="file-name">{{ file.fileName }}</span>
                                                <button type="button" class="remove-file"
                                                    (click)="removeEditFile(comment, fi)" title="Remove">
                                                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                                                        <path d="M7 3L3 7M3 3L7 7" stroke="currentColor"
                                                            stroke-width="1.5" stroke-linecap="round" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="edit-actions">
                                        <button type="button" class="btn btn-sm btn-secondary"
                                            (click)="cancelCommentEdit(comment)">Cancel</button>
                                        <button type="button" class="btn btn-sm btn-primary"
                                            (click)="saveCommentEdit(comment)">Save</button>
                                        <!-- <button type="button" class="attach-edit-btn" (click)="editFileInput.click()"
                                            title="Add attachment">
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                <path
                                                    d="M7.5 1.5L7.5 9C7.5 10.1046 6.60457 11 5.5 11C4.39543 11 3.5 10.1046 3.5 9V4.5C3.5 3.94772 3.94772 3.5 4.5 3.5C5.05228 3.5 5.5 3.94772 5.5 4.5V8.5"
                                                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </button> -->
                                    </div>
                                </div>

                                <!-- Comment Attachments -->
                                <div class="comment-attachments"
                                    *ngIf="comment.documents && comment.documents.length > 0">
                                    <div class="attachment-chip" *ngFor="let doc of comment.documents"
                                        (click)="viewFile(doc)">
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                            <path
                                                d="M7 1H3C2.44772 1 2 1.44772 2 2V10C2 10.5523 2.44772 11 3 11H9C9.55228 11 10 10.5523 10 10V4L7 1Z"
                                                stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                                            <path d="M7 1V4H10" stroke="currentColor" stroke-width="1.5"
                                                stroke-linejoin="round" />
                                        </svg>
                                        <span>{{ doc.fileName }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Add Comment Section -->
                    <div class="add-comment-section">
                        <div class="comment-avatar-wrapper">
                            <img *ngIf="currentUser?.avatar" [src]="currentUser?.avatar" [alt]="currentUser?.username"
                                class="comment-avatar">
                            <div *ngIf="!currentUser?.avatar" class="comment-avatar initials">
                                {{ getUserInitials(currentUser?.username || "") }}
                            </div>
                        </div>

                        <div class="comment-input-wrapper">
                            <div>
                                <div #newCommentEditor class="new-comment-editor"></div>
                            </div>

                            <!-- New Comment Files -->
                            <div class="file-chips" *ngIf="newCommentFiles.length > 0">
                                <div class="file-chip" *ngFor="let file of newCommentFiles; let i = index">
                                    <div class="file-info">
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" class="file-icon">
                                            <path
                                                d="M9 1H4C3.44772 1 3 1.44772 3 2V14C3 14.5523 3.44772 15 4 15H12C12.5523 15 13 14.5523 13 14V5L9 1Z"
                                                stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                                            <path d="M9 1V5H13" stroke="currentColor" stroke-width="1.5"
                                                stroke-linejoin="round" />
                                        </svg>
                                        <div class="file-details">
                                            <span class="file-name">{{ file.fileName }}</span>
                                            <span class="file-size">{{ formatFileSize(file.fileSize) }}</span>
                                        </div>
                                    </div>
                                    <div class="file-actions">
                                        <button type="button" class="action-btn view-btn" (click)="viewFile(file)"
                                            title="View">
                                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                <path d="M1 6C1 6 3 2 6 2C9 2 11 6 11 6C11 6 9 10 6 10C3 10 1 6 1 6Z"
                                                    stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                                                <circle cx="6" cy="6" r="2" stroke="currentColor" stroke-width="1.5" />
                                            </svg>
                                        </button>
                                        <button type="button" class="action-btn delete-btn"
                                            (click)="deleteCommentFile(i)" title="Delete">
                                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                <path d="M9 3L3 9M3 3L9 9" stroke="currentColor" stroke-width="1.5"
                                                    stroke-linecap="round" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="comment-input-actions">
                                <!-- <button type="button" class="attach-comment-btn" (click)="commentFileInput.click()"
                                    title="Add attachment">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path
                                            d="M8.5 2L8.5 10.5C8.5 11.8807 7.38071 13 6 13C4.61929 13 3.5 11.8807 3.5 10.5V5.5C3.5 4.67157 4.17157 4 5 4C5.82843 4 6.5 4.67157 6.5 5.5V10"
                                            stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                                    </svg>
                                </button> -->
                                <button type="button" class="btn btn-sm btn-primary" (click)="addComment()"
                                    [disabled]="!getNewCommentText().trim() && newCommentFiles.length === 0">
                                    Comment
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Activity Log Section -->
                <div class="activity-log-section" *ngIf="activities.length > 0">
                    <h3 class="section-title">Activity Timeline</h3>
                    <div class="activity-list">
                        <div class="activity-item" *ngFor="let activity of activities">
                            <div class="activity-avatar">
                                <div class="activity-avatar initials">
                                    {{ getUserInitials(activity.crmUser?.username || 'Unknown') }}
                                </div>
                            </div>
                            <div class="activity-content">
                                <div class="activity-header">
                                    <span class="activity-user">{{ activity.crmUser?.username || 'Unknown User'
                                        }}</span>
                                    <span class="activity-time">{{ formatActivityDate(activity.timestamp) }}</span>
                                </div>
                                <div class="activity-description">
                                    <span class="activity-action">{{ formatActivityAction(activity.action) }}</span>
                                    <span class="activity-details"
                                        [innerHTML]="formatActivityDetails(activity.details)"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
            <button type="button" class="btn btn-primary" (click)="saveTask()"
                [disabled]="(taskForm.invalid) || isLoading() || !hasChanges">
                {{ isLoading() ? 'Saving...' : 'Save' }}
            </button>
        </div>
    </div>
</div>

<!-- Hidden file inputs -->
<input #commentFileInput type="file" multiple class="hidden" (change)="onCommentFileSelected($event)">
<input #editFileInput type="file" multiple class="hidden" (change)="onEditFileSelected($event)">